<script setup lang="ts">
import type { Size, Color } from './TextCommon'

withDefaults(
  defineProps<{
    size?: Size
    color?: Color
  }>(),
  {
    size: 'medium',
    color: 'neutral-default',
  }
)
</script>

<template>
  <p
    :class="{
      [size]: true,
      [color]: true,
    }"
  >
    <slot></slot>
  </p>
</template>

<style lang="scss" scoped>
.large {
  @include textToken.body-large;
}

.medium {
  @include textToken.body-medium;
}

.small {
  @include textToken.body-small;
}

.brand-strong {
  color: var(--semantic-tokens-brand-strong-text);
}

.success-strong {
  color: var(--semantic-tokens-success-strong-text);
}

.success-default {
  color: var(--semantic-tokens-success-default-text);
}

.danger-strong {
  color: var(--semantic-tokens-danger-default-text);
}

.attention-strong {
  color: var(--semantic-tokens-attention-strong-text);
}

.attention-default {
  color: var(--semantic-tokens-attention-default-text);
}

.attention-secondary-default {
  color: var(--semantic-tokens-attention-secondary-default-text);
}

.neutral-default {
  color: var(--semantic-tokens-neutral-default-text);
}

.neutral-weak {
  color: var(--semantic-tokens-neutral-weak-text);
}

.inverse-default {
  color: var(--semantic-tokens-inverse-default-text);
}
</style>
